/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CatalogEntry,
  CatalogEntry$inboundSchema,
  CatalogEntry$Outbound,
  CatalogEntry$outboundSchema,
} from "./catalogentry.js";

export type RegistryManagementListResponse = {
  object: "list";
  data: Array<CatalogEntry>;
};

/** @internal */
export const RegistryManagementListResponse$inboundSchema: z.ZodType<
  RegistryManagementListResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(CatalogEntry$inboundSchema),
});
/** @internal */
export type RegistryManagementListResponse$Outbound = {
  object: "list";
  data: Array<CatalogEntry$Outbound>;
};

/** @internal */
export const RegistryManagementListResponse$outboundSchema: z.ZodType<
  RegistryManagementListResponse$Outbound,
  z.ZodTypeDef,
  RegistryManagementListResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(CatalogEntry$outboundSchema),
});

export function registryManagementListResponseToJSON(
  registryManagementListResponse: RegistryManagementListResponse,
): string {
  return JSON.stringify(
    RegistryManagementListResponse$outboundSchema.parse(
      registryManagementListResponse,
    ),
  );
}
export function registryManagementListResponseFromJSON(
  jsonString: string,
): SafeParseResult<RegistryManagementListResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RegistryManagementListResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegistryManagementListResponse' from JSON`,
  );
}
